export default "__VITE_ASSET__DLVaBIv0__"